import {SpyneTrait, ViewStream} from 'spyne';
import {CodeContainerPropertiesContentCustomItems} from 'components/code-examples/code-container-properties-content-custom-items';

export class CodeContainerPropertyTraits extends SpyneTrait {

  constructor(context){
    let traitPrefix = "codeContainer$";

    super(context, traitPrefix);
  }

  static codeContainer$AddCustomItems(customContent={}){
    const {selector, content} = customContent;

    console.log("custom content is ",{customContent})
    const vs =  new CodeContainerPropertiesContentCustomItems({data: customContent})

    this.appendView(vs, selector);
  }

}

